'use strict';

var app = require('mag-app'),
    dom = require('spa-dom'),
    tag = dom.tag;


/**
 * Prepare data for series list.
 *
 * @param {Object} data - data to prepare
 * @param {boolean} all - all series to render
 *
 * @return {Array} prepared data
 */
module.exports = function ( data, all ) {
    var length = 0,
        result = [],
        index, $focusWrapper, $blurWrapper,
        $title, $container;

    if ( data.length <= app.metrics.seasonsList.size || all ) {
        length = data.length;
    } else {
        length = app.metrics.seasonsList.size;
    }

    if ( data && data.length ) {
        for ( index = 0; index < length; index++ ) {
            data[index].type = app.config.types.season;
            data[index].custName = gettext('Season') + ' ' + data[index].number
                + (data[index].name
                    ? ' - ' + data[index].name
                    : data[index].original_name ? ' - ' +  data[index].original_name : '');

            $title = tag('div', {className: 'itemTitle'}, data[index].custName);
            $container = tag('div', {className: 'container'}, $title);
            $focusWrapper = tag('div', {className: 'focusWrapper'}, $container);
            $title = tag('div', {className: 'itemTitle'}, data[index].custName);
            $container = tag('div', {className: 'container'}, $title);
            $blurWrapper = tag('div', {className: 'blurWrapper'}, $container);
            result.push({
                items: [
                    $focusWrapper,
                    $blurWrapper
                ],
                value: data[index]
            });
        }
    }

    return result;
};
